/* eslint-disable @typescript-eslint/no-namespace */
/**
 * SIP Methods
 * @internal
 */
export namespace C {
  export const ACK = "ACK";
  export const BYE = "BYE";
  export const CANCEL = "CANCEL";
  export const INFO = "INFO";
  export const INVITE = "INVITE";
  export const MESSAGE = "MESSAGE";
  export const NOTIFY = "NOTIFY";
  export const OPTIONS = "OPTIONS";
  export const REGISTER = "REGISTER";
  export const UPDATE = "UPDATE";
  export const SUBSCRIBE = "SUBSCRIBE";
  export const PUBLISH = "PUBLISH";
  export const REFER = "REFER";
  export const PRACK = "PRACK";
}
